export default __webpack_public_path__ + "static/media/_1.0dd19b85.png";